"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserPreviousItemsCount = void 0;
var apiService_1 = __importDefault(require("@common/services/apiService"));
var i18n_1 = __importDefault(require("@/react-app/i18n"));
var roundNumber_1 = require("./roundNumber");
var implioFilters_1 = require("@/react-app/features/Search/FilterBar/FilterSideBar/implioFilters");
var getUserPreviousItemsCount = function (domain, userId, controller) { return __awaiter(void 0, void 0, void 0, function () {
    var status, promises, userPreviousItemsCountArray;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                status = [
                    { status: 'APPROVE', tooltip: i18n_1.default.t('ITEM.STATUS_REACT.approved') },
                    { status: 'REFUSE', tooltip: i18n_1.default.t('ITEM.STATUS_REACT.refused') },
                ];
                promises = status.map(function (item) {
                    return apiService_1.default.getUserPreviousItemsCount({
                        domain: domain,
                        userId: userId,
                        status: item.status,
                    }, undefined, controller);
                });
                userPreviousItemsCountArray = [];
                return [4 /*yield*/, Promise.all(promises)
                        .then(function (data) {
                        var sum = data.reduce(function (acc, cur) { return acc + cur.data.count; }, 0);
                        status.forEach(function (statusItem, index) {
                            var count = data[index].data.count;
                            var percentage = (count / sum) * 100;
                            var countInPercentage = "".concat((0, roundNumber_1.roundNumber)(percentage, 1), "%");
                            var filters = count > 0 ? [{ id: implioFilters_1.filterKey.userId, value: userId }] : [];
                            userPreviousItemsCountArray.push({
                                count: count,
                                countInPercentage: countInPercentage,
                                filters: filters,
                                tooltip: statusItem.tooltip,
                                status: statusItem.status,
                            });
                        });
                        // we need state variables for userCountFetched and userPreviousItemsCountArray to see the changes reflected in the UI
                        // that's why I'm not not using the job class setter job.setUserCountFetched(true); and job.setUserPreviousItemsCount(userPreviousItemsCountArray);
                        // and this service is returning instead userPreviousItemsCountArray
                    })
                        .catch(function (error) {
                        console.error('error', error);
                    })];
            case 1:
                _a.sent();
                return [2 /*return*/, userPreviousItemsCountArray];
        }
    });
}); };
exports.getUserPreviousItemsCount = getUserPreviousItemsCount;
